export default "__VITE_ASSET__vk29NddY__"